/*
 * Modulo redux del IGI (Indice de Gestion Integral). Reducer `igi_module`:
 *  - _get_all_criterios / _update_criterio: catalogo de criterios (etapa 1).
 *  - _get_resumen: GET /igi/resumen/ ("Mi zona": data.datos = zonas con tiendas, data.alertas).
 *  - _get_evaluaciones_tienda: GET /igi/tiendas/<id>/evaluaciones/ (data.datos + data.tienda).
 *  - _create_evaluacion / _update_evaluacion: POST y PATCH de evaluaciones.
 *  - _get_visitas_tienda / _create_visita / _update_visita / _delete_visita: GET/POST
 *    /igi/tiendas/<id>/visitas/ y PUT/DELETE /igi/visitas/<id>/.
 *  - _get_retro / _create_retro: GET/POST /igi/retro/ (por ?zona= o ?tienda=).
 *  - _get_trafico_dispositivos: GET /igi/trafico/dispositivos/ (mapeo device_id -> tienda/zona).
 *  - _get_trafico_ranking / _get_trafico_chart / _get_trafico_hourly: RPC directas a Supabase
 *    (get_ranking_devices/get_chart_devices/get_hourly_devices, config/supabaseTrafico.js) — no
 *    pasan por el backend de Django. data es un array en estos tres (nunca un objeto).
 *  - _cargar_erp: POST /igi/erp/cargar/ (multipart: archivo, metrica, mes). El payload trae ademas
 *    `metrica` (eco del parametro) para que las 6 tarjetas de carga (misma pantalla, un slice
 *    compartido) distingan a cual de ellas pertenece cada respuesta.
 *  - _get_erp_comparativa: GET /igi/erp/comparativa/ (?metrica=&mes=&zona=). El payload trae
 *    ademas `clave` (eco del 3er argumento del thunk) para que la pantalla descarte respuestas que
 *    ya no corresponden al filtro vigente (mismo patron "vigente" que _get_trafico_*).
 * Cada entrada es {data, status, message}; status 0 = sin resultado todavia; clear_igi(type) la
 * reinicia. En error, message = `mensaje` del backend. Se limpia al hacer LOGOUT.
 */
import axios from "axios";
import {
    URLAPI,
    IGI_CRITERIOS_PATH,
    IGI_RESUMEN_PATH,
    IGI_TIENDAS_PATH,
    IGI_EVALUACIONES_PATH,
    IGI_VISITAS_PATH,
    IGI_RETRO_PATH,
    IGI_TRAFICO_DISPOSITIVOS_PATH,
    IGI_ERP_CARGAR_PATH,
    IGI_ERP_COMPARATIVA_PATH,
} from "../config/index";
import {getRankingDevices, getChartDevices, getHourlyDevices} from "../config/supabaseTrafico";
import {LOGOUT} from './users'

const init = {
    _get_all_criterios: {
        data: [],
        status: 0,
        message: {},
    },
    _update_criterio: {
        data: {},
        status: 0,
        message: {},
    },
    _get_resumen: {
        data: {},
        status: 0,
        message: {},
    },
    _get_evaluaciones_tienda: {
        data: {},
        status: 0,
        message: {},
    },
    _create_evaluacion: {
        data: {},
        status: 0,
        message: {},
    },
    _update_evaluacion: {
        data: {},
        status: 0,
        message: {},
    },
    _get_visitas_tienda: {
        data: {},
        status: 0,
        message: {},
    },
    _create_visita: {
        data: {},
        status: 0,
        message: {},
    },
    _update_visita: {
        data: {},
        status: 0,
        message: {},
    },
    _delete_visita: {
        data: {},
        status: 0,
        message: {},
    },
    _get_retro: {
        data: {},
        status: 0,
        message: {},
    },
    _create_retro: {
        data: {},
        status: 0,
        message: {},
    },
    _get_trafico_dispositivos: {
        data: {},
        status: 0,
        message: {},
    },
    _get_trafico_ranking: {
        data: [],
        status: 0,
        message: {},
    },
    _get_trafico_chart: {
        data: [],
        status: 0,
        message: {},
    },
    _get_trafico_hourly: {
        data: [],
        status: 0,
        message: {},
    },
    _cargar_erp: {
        data: {},
        status: 0,
        message: {},
    },
    _get_erp_comparativa: {
        data: {},
        status: 0,
        message: {},
    },
};

const GET_ALL_CRITERIOS_SUCCESS = "GET_ALL_CRITERIOS_SUCCESS";
export const UPDATE_CRITERIO_SUCCESS = "UPDATE_CRITERIO_SUCCESS";
export const GET_IGI_RESUMEN_SUCCESS = "GET_IGI_RESUMEN_SUCCESS";
export const GET_EVALUACIONES_TIENDA_SUCCESS = "GET_EVALUACIONES_TIENDA_SUCCESS";
export const CREATE_EVALUACION_SUCCESS = "CREATE_EVALUACION_SUCCESS";
export const UPDATE_EVALUACION_SUCCESS = "UPDATE_EVALUACION_SUCCESS";
export const GET_VISITAS_TIENDA_SUCCESS = "GET_VISITAS_TIENDA_SUCCESS";
export const CREATE_VISITA_SUCCESS = "CREATE_VISITA_SUCCESS";
export const UPDATE_VISITA_SUCCESS = "UPDATE_VISITA_SUCCESS";
export const DELETE_VISITA_SUCCESS = "DELETE_VISITA_SUCCESS";
export const GET_RETRO_SUCCESS = "GET_RETRO_SUCCESS";
export const CREATE_RETRO_SUCCESS = "CREATE_RETRO_SUCCESS";
export const GET_TRAFICO_DISPOSITIVOS_SUCCESS = "GET_TRAFICO_DISPOSITIVOS_SUCCESS";
export const GET_TRAFICO_RANKING_SUCCESS = "GET_TRAFICO_RANKING_SUCCESS";
export const GET_TRAFICO_CHART_SUCCESS = "GET_TRAFICO_CHART_SUCCESS";
export const GET_TRAFICO_HOURLY_SUCCESS = "GET_TRAFICO_HOURLY_SUCCESS";
export const CARGAR_ERP_SUCCESS = "CARGAR_ERP_SUCCESS";
export const GET_ERP_COMPARATIVA_SUCCESS = "GET_ERP_COMPARATIVA_SUCCESS";

export const igi_module = (state = init, action) => {
    switch (action.type) {
        case GET_ALL_CRITERIOS_SUCCESS:
            return {
                ...state,
                _get_all_criterios: action.payload,
            };
        case UPDATE_CRITERIO_SUCCESS:
            return {
                ...state,
                _update_criterio: action.payload,
            };
        case GET_IGI_RESUMEN_SUCCESS:
            return {
                ...state,
                _get_resumen: action.payload,
            };
        case GET_EVALUACIONES_TIENDA_SUCCESS:
            return {
                ...state,
                _get_evaluaciones_tienda: action.payload,
            };
        case CREATE_EVALUACION_SUCCESS:
            return {
                ...state,
                _create_evaluacion: action.payload,
            };
        case UPDATE_EVALUACION_SUCCESS:
            return {
                ...state,
                _update_evaluacion: action.payload,
            };
        case GET_VISITAS_TIENDA_SUCCESS:
            return {
                ...state,
                _get_visitas_tienda: action.payload,
            };
        case CREATE_VISITA_SUCCESS:
            return {
                ...state,
                _create_visita: action.payload,
            };
        case UPDATE_VISITA_SUCCESS:
            return {
                ...state,
                _update_visita: action.payload,
            };
        case DELETE_VISITA_SUCCESS:
            return {
                ...state,
                _delete_visita: action.payload,
            };
        case GET_RETRO_SUCCESS:
            return {
                ...state,
                _get_retro: action.payload,
            };
        case CREATE_RETRO_SUCCESS:
            return {
                ...state,
                _create_retro: action.payload,
            };
        case GET_TRAFICO_DISPOSITIVOS_SUCCESS:
            return {
                ...state,
                _get_trafico_dispositivos: action.payload,
            };
        case GET_TRAFICO_RANKING_SUCCESS:
            return {
                ...state,
                _get_trafico_ranking: action.payload,
            };
        case GET_TRAFICO_CHART_SUCCESS:
            return {
                ...state,
                _get_trafico_chart: action.payload,
            };
        case GET_TRAFICO_HOURLY_SUCCESS:
            return {
                ...state,
                _get_trafico_hourly: action.payload,
            };
        case CARGAR_ERP_SUCCESS:
            return {
                ...state,
                _cargar_erp: action.payload,
            };
        case GET_ERP_COMPARATIVA_SUCCESS:
            return {
                ...state,
                _get_erp_comparativa: action.payload,
            };
        case LOGOUT:
            return init;
        default:
            return state;
    }
};

const failure = (type, error) => ({
    type: type,
    payload: {
        data: {},
        status: error.response != null ? error.response.status : 500,
        message: error.response != null ? error.response.data.mensaje : error.message,
    },
});

const success = (type, response) => ({
    type: type,
    payload: {
        data: response.data,
        status: response.status,
        message: "",
    },
});

const supabaseSuccess = (type, datos, clave) => ({
    type: type,
    payload: {data: Array.isArray(datos) ? datos : [], status: 200, message: "", clave},
});

const supabaseFailure = (type, error, clave) => ({
    type: type,
    payload: {data: [], status: 500, message: error.message, clave},
});

const auth = (token) => ({
    headers: {
        Authorization: `Token ${token}`,
    },
});

export const get_all_criterios = (token) => async (dispatch) => {
    try {
        const response = await axios.get(`${URLAPI}${IGI_CRITERIOS_PATH}`, {
            headers: {
                Authorization: `Token ${token}`,
            },
        });
        dispatch({
            type: GET_ALL_CRITERIOS_SUCCESS,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        dispatch(failure(GET_ALL_CRITERIOS_SUCCESS, error));
    }
}

export const update_criterio = (token, id, data) => async (dispatch) => {
    try {
        const response = await axios.patch(`${URLAPI}${IGI_CRITERIOS_PATH}${id}/`, data, {
            headers: {
                Authorization: `Token ${token}`,
            },
        });
        dispatch({
            type: UPDATE_CRITERIO_SUCCESS,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        dispatch(failure(UPDATE_CRITERIO_SUCCESS, error));
    }
}

export const get_igi_resumen = (token) => async (dispatch) => {
    try {
        const response = await axios.get(`${URLAPI}${IGI_RESUMEN_PATH}`, auth(token));
        dispatch(success(GET_IGI_RESUMEN_SUCCESS, response));
    } catch (error) {
        dispatch(failure(GET_IGI_RESUMEN_SUCCESS, error));
    }
}

export const get_evaluaciones_tienda = (token, tiendaId) => async (dispatch) => {
    try {
        const response = await axios.get(`${URLAPI}${IGI_TIENDAS_PATH}${tiendaId}/evaluaciones/`, auth(token));
        dispatch(success(GET_EVALUACIONES_TIENDA_SUCCESS, response));
    } catch (error) {
        dispatch(failure(GET_EVALUACIONES_TIENDA_SUCCESS, error));
    }
}

export const create_evaluacion = (token, tiendaId, data) => async (dispatch) => {
    try {
        const response = await axios.post(`${URLAPI}${IGI_TIENDAS_PATH}${tiendaId}/evaluaciones/`, data, auth(token));
        dispatch(success(CREATE_EVALUACION_SUCCESS, response));
    } catch (error) {
        dispatch(failure(CREATE_EVALUACION_SUCCESS, error));
    }
}

export const update_evaluacion = (token, id, data) => async (dispatch) => {
    try {
        const response = await axios.patch(`${URLAPI}${IGI_EVALUACIONES_PATH}${id}/`, data, auth(token));
        dispatch(success(UPDATE_EVALUACION_SUCCESS, response));
    } catch (error) {
        dispatch(failure(UPDATE_EVALUACION_SUCCESS, error));
    }
}

export const get_visitas_tienda = (token, tiendaId) => async (dispatch) => {
    try {
        const response = await axios.get(`${URLAPI}${IGI_TIENDAS_PATH}${tiendaId}/visitas/`, auth(token));
        dispatch(success(GET_VISITAS_TIENDA_SUCCESS, response));
    } catch (error) {
        dispatch(failure(GET_VISITAS_TIENDA_SUCCESS, error));
    }
}

export const create_visita = (token, tiendaId, data) => async (dispatch) => {
    try {
        const response = await axios.post(`${URLAPI}${IGI_TIENDAS_PATH}${tiendaId}/visitas/`, data, auth(token));
        dispatch(success(CREATE_VISITA_SUCCESS, response));
    } catch (error) {
        dispatch(failure(CREATE_VISITA_SUCCESS, error));
    }
}

export const update_visita = (token, id, data) => async (dispatch) => {
    try {
        const response = await axios.put(`${URLAPI}${IGI_VISITAS_PATH}${id}/`, data, auth(token));
        dispatch(success(UPDATE_VISITA_SUCCESS, response));
    } catch (error) {
        dispatch(failure(UPDATE_VISITA_SUCCESS, error));
    }
}

export const delete_visita = (token, id) => async (dispatch) => {
    try {
        const response = await axios.delete(`${URLAPI}${IGI_VISITAS_PATH}${id}/`, auth(token));
        dispatch(success(DELETE_VISITA_SUCCESS, response));
    } catch (error) {
        dispatch(failure(DELETE_VISITA_SUCCESS, error));
    }
}

export const get_retro = (token, params) => async (dispatch) => {
    const tieneZona = params.zona !== undefined && params.zona !== null;
    const tieneTienda = params.tienda !== undefined && params.tienda !== null;
    if (tieneZona === tieneTienda) {
        dispatch({
            type: GET_RETRO_SUCCESS,
            payload: {
                data: {},
                status: 406,
                message: "Debe indicar exactamente una zona o una tienda",
            },
        });
        return;
    }
    try {
        const query = tieneZona ? `?zona=${params.zona}` : `?tienda=${params.tienda}`;
        const response = await axios.get(`${URLAPI}${IGI_RETRO_PATH}${query}`, auth(token));
        dispatch(success(GET_RETRO_SUCCESS, response));
    } catch (error) {
        dispatch(failure(GET_RETRO_SUCCESS, error));
    }
}

export const create_retro = (token, data) => async (dispatch) => {
    try {
        const response = await axios.post(`${URLAPI}${IGI_RETRO_PATH}`, data, auth(token));
        dispatch(success(CREATE_RETRO_SUCCESS, response));
    } catch (error) {
        dispatch(failure(CREATE_RETRO_SUCCESS, error));
    }
}

export const get_trafico_dispositivos = (token) => async (dispatch) => {
    try {
        const response = await axios.get(`${URLAPI}${IGI_TRAFICO_DISPOSITIVOS_PATH}`, auth(token));
        dispatch(success(GET_TRAFICO_DISPOSITIVOS_SUCCESS, response));
    } catch (error) {
        dispatch(failure(GET_TRAFICO_DISPOSITIVOS_SUCCESS, error));
    }
}

export const get_trafico_ranking = (from, to, deviceIds, clave) => async (dispatch) => {
    try {
        const datos = await getRankingDevices(from, to, deviceIds);
        dispatch(supabaseSuccess(GET_TRAFICO_RANKING_SUCCESS, datos, clave));
    } catch (error) {
        dispatch(supabaseFailure(GET_TRAFICO_RANKING_SUCCESS, error, clave));
    }
}

export const get_trafico_chart = (from, to, deviceIds, clave) => async (dispatch) => {
    try {
        const datos = await getChartDevices(from, to, deviceIds);
        dispatch(supabaseSuccess(GET_TRAFICO_CHART_SUCCESS, datos, clave));
    } catch (error) {
        dispatch(supabaseFailure(GET_TRAFICO_CHART_SUCCESS, error, clave));
    }
}

export const get_trafico_hourly = (from, to, deviceIds, clave) => async (dispatch) => {
    try {
        const datos = await getHourlyDevices(from, to, deviceIds);
        dispatch(supabaseSuccess(GET_TRAFICO_HOURLY_SUCCESS, datos, clave));
    } catch (error) {
        dispatch(supabaseFailure(GET_TRAFICO_HOURLY_SUCCESS, error, clave));
    }
}

export const clear_igi = (type) => async (dispatch) => {
    dispatch({
        type: type,
        payload: {
            data: {},
            status: 0,
            message: {},
        },
    });
}

export const cargar_erp = (token, {archivo, metrica, mes}) => async (dispatch) => {
    try {
        const form = new FormData();
        form.append('archivo', archivo);
        form.append('metrica', metrica);
        form.append('mes', mes);
        const response = await axios.post(`${URLAPI}${IGI_ERP_CARGAR_PATH}`, form, auth(token));
        dispatch({
            type: CARGAR_ERP_SUCCESS,
            payload: {data: response.data, status: response.status, message: "", metrica},
        });
    } catch (error) {
        dispatch({
            type: CARGAR_ERP_SUCCESS,
            payload: {
                data: {},
                status: error.response ? error.response.status : 500,
                message: error.response ? error.response.data.mensaje : error.message,
                metrica,
            },
        });
    }
}

export const get_erp_comparativa = (token, {metrica, mes, zona}, clave) => async (dispatch) => {
    try {
        const query = `?metrica=${metrica}&mes=${mes}${zona ? `&zona=${zona}` : ""}`;
        const response = await axios.get(`${URLAPI}${IGI_ERP_COMPARATIVA_PATH}${query}`, auth(token));
        dispatch({
            type: GET_ERP_COMPARATIVA_SUCCESS,
            payload: {data: response.data, status: response.status, message: "", clave},
        });
    } catch (error) {
        dispatch({
            type: GET_ERP_COMPARATIVA_SUCCESS,
            payload: {
                data: {},
                status: error.response ? error.response.status : 500,
                message: error.response ? error.response.data.mensaje : error.message,
                clave,
            },
        });
    }
}
